import axios from 'axios';
import BASEURL from '../BaseUrl';
import { logoutApi } from './AuthApi';

export const addToFavourite = async (workflow_id) => {
  try {
    const token = JSON.parse(sessionStorage.getItem('jwtToken'));
    if (!token) throw new Error('No token found');

    const response = await axios.put(
      `${BASEURL}/workflow/add-to-fav`,
      { workflowId: workflow_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error('Error adding favorite:', error);
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const removeFromFavourite = async (workflow_id) => {
  try {
    const token = JSON.parse(sessionStorage.getItem('jwtToken'));
    if (!token) throw new Error('No token found');

    const response = await axios.put(
      `${BASEURL}/workflow/remove-from-fav`,
      { workflowId: workflow_id },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response;
  } catch (error) {
    console.error('Error removing favorite:', error);
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllFavourite = async (payload) => {
  try {
    const token = JSON.parse(sessionStorage.getItem('jwtToken'));
    if (!token) throw new Error('No token found');

    return await axios.get(`${BASEURL}/workflow/get-all-fav`, {
      headers: { Authorization: `Bearer ${token}` },
      params: payload,
    });
  } catch (error) {
    console.error('Error fetching favorites:', error);
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const deleteWorkflowApi = async (workflow_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.delete(`${BASEURL}/workflow/delete-workflow`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { workflow_id },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowByUserGroupAndEngagementIdApi = async (group, engagement_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-by-userGroup-and-engagementId`, {
      params: {
        user_group: group,
        engagement_id,
      },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowByClientIdApi = async (client_id, page, size, search = '', status = '') => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-by-clientId`, {
      params: {
        client_id,
        page,
        size,
        workflowName: search || null,
        status: status || null,
      },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowByUserGroup = async (user_group) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-by-userGroup`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { user_group },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowByUserGroupAndDomainId = async (user_group, domain_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-by-userGroup-domainId`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { user_group, domain_id },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowByUserGroupAndProcessType = async (user_group, process_type) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-by-userGroup-and-processType`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { user_group, process_type },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowByUserGroupAndDomainIdAndProcessType = async (user_group, domain_id, process_type) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-by-userGroup-and-processType-and-domainId`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { user_group, domain_id, process_type },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllWorkflowByDomainIdAndProcessType = async (domain_id, process_type) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-all-workflow-by-domainId-and-processType`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { domain_id, process_type },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllWorkflowByProcessType = async (process_type) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-all-workflow-by-processType`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { process_type },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const createWorkflowApi = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/workflow/create-workflow`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowById = async (workflow_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-by-id`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { workflow_id },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowList = async (process_type) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-list`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { process_type },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getPendingWorkflowApi = async (page = 0, size = 5) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-pending-workflow`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: { page, size },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllWorkflowApi = async (payload) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-all-workflows`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: payload,
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllWorkflowByDomainIdApi = async (domain_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-all-workflow-by-domainId`, {
      params: { domain_id },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getAllWorkflowIdNameByEngagementIdApi = async (engagement_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-all-workflow-id-name-by-engagementId`, {
      params: { engagement_id },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const approveWorkflowApi = async (workflow_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/approve-workflow`, {
      params: { workflow_id },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const rejectWorkflowApi = async (workflow_id) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/reject-workflow`, {
      params: { workflow_id },
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const copyWorkflowApi = async (data) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.post(`${BASEURL}/workflow/copy-job`, data, {
      headers: { Authorization: `Bearer ${parseToken}` },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getWorkflowByUserGroupAndEngagementIdAgenticApi = async (payload) => {
  try {
    const parseToken = JSON.parse(sessionStorage.getItem('jwtToken'));
    return await axios.get(`${BASEURL}/workflow/get-workflow-by-userGroup-engagementId-processType`, {
      headers: { Authorization: `Bearer ${parseToken}` },
      params: {
        user_group: payload.userGroup,
        engagement_id: payload.engagementId,
      },
    });
  } catch (error) {
    if (error.response.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};
